document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.tabbed-button').forEach((button) => {
      button.addEventListener('click', function () {
          if (!this.classList.contains('active')) {
              document.querySelector('.tabbed-button.active').classList.remove('active');
              document.querySelector('.tabbed-start.active').classList.remove('active');
              this.classList.add('active');
              document.getElementById(this.dataset.id).classList.add('active');
              if (this.dataset.id != 'size-guide') {
                  document.querySelectorAll('.custom-table-row').forEach((row) => {
                      if (row.dataset.id != this.dataset.id) {
                          row.style.display = 'none';
                      } else {
                          row.style.display = 'table-row';
                      }
                  })
              } else {
                  document.querySelectorAll('.custom-table tr').forEach((row) => {
                      row.style.display = 'table-row';
                  })
              }
          }
  
      })
  })
})
